import React, { useState } from "react";
import { LabelProps } from "../../../../../utils/types";
import { TextField } from "@mui/material";
import Info from "../../../../../images/Info.svg";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import ViewAsset from "../stockentry/ViewAsset";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import useFormJson from "../../../../../json/useFormJson";

const ItemDetails = () => {
  const [viewAsset, setViewAsset] = useState(false);
const {StockBalance}=useFormJson();
  return (
    <>
      <div className="stock-balance-add__select">
        {StockBalance.Add.map((label: LabelProps, index: React.Key) => {
          if (label.inputName === "description") {
            return (
              <div className="stock-balance-add__select--flex">
                <TextField
                  label={label.labelName}
                  value={label.inputName}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  disabled
                  className="stock-balance-add__select--textfield"
                />
                <img
                  src={Info}
                  alt=""
                  onClick={() => setViewAsset(!viewAsset)}
                />
              </div>
            );
          }
          return (
            <React.Fragment key={index}>
              <TextField
                label={label.labelName}
                value={label.inputName}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                disabled
                className="stock-balance-add__select--textfield"
              />
            </React.Fragment>
          );
        })}
      </div>
      <CustomModal
        isOpen={viewAsset}
        onRequestClose={() => setViewAsset(!viewAsset)}
        contentComponent={<ViewAsset setModalFlag={setViewAsset} itemId={0} />}
        style={ViewModalStyles}
      />
    </>
  );
};

export default ItemDetails;
